import * as React from 'react';
import useViewer from 'hooks/useViewer';
import Head from 'components/Head';
import { AuthStatus } from 'constants/auth';
import { auth } from 'services/client/firebase';
import api from 'services/client/api';
import SettingsPage from './SettingsPage';
import { SettingsApiResponse } from './props';

const TITLE = 'My Account';
const DESCRIPTION = 'User settings page';

const SettingsPageContainer = () => {
  const viewer = useViewer();
  const [settings, setSettings] = React.useState<null | SettingsApiResponse>(null);

  React.useEffect(() => {
    if (viewer.status === AuthStatus.User) {
      auth.currentUser
        ?.getIdToken(true)
        .then((idToken) => {
          return api.post('my/settings', {
            payload: {
              token: idToken,
            },
          });
        })
        .then((resp) => {
          setSettings(resp as SettingsApiResponse);
        });
    }
  }, [viewer.status]);

  return (
    <>
      <Head title={TITLE} description={DESCRIPTION} useCurrentUrl />

      <SettingsPage viewer={viewer} settings={settings} />
    </>
  );
};

export default SettingsPageContainer;
